import { createSlice } from '@reduxjs/toolkit';

interface LoginState {
  channel: OTPSendType;
  type: LoginType;
  source: SourceEventsData;
}

const initialState = {
  channel: 'sms',
  type: 'core-checkout',
  source: 'default',
} as LoginState;

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    initialize: (_state, action) => action.payload,
    setChannel: (state, action) => ({ ...state, channel: action.payload }),
  },
});

export const { initialize, setChannel } = loginSlice.actions;

export default loginSlice.reducer;
